import { ITagProps, Tag, TAG_VARIANTS, tagClasses } from '@private/components';
import { getFontBase, getPrefixedVar } from '@private/payment';
import styled, { css } from 'styled-components';

import { ThemedElement } from 'utils/types';

const buttonPrefix = ['components', 'tag', 'button'];

export default styled(Tag)<ThemedElement<ITagProps>>`
  ${tagClasses.text} {
    line-height: 133%;
  }

  ${({ themePrefix, variant = TAG_VARIANTS.SUCCESS }) => {
    const prefix = themePrefix || ['components', 'tag', variant];

    return css`
      background: ${getPrefixedVar(prefix, 'bg')};
      color: ${getPrefixedVar(prefix, 'text')};

      ${tagClasses.text} {
        max-width: none;
        ${getFontBase(prefix)}
      }

      ${tagClasses.button} {
        color: inherit;
        background: ${getPrefixedVar(buttonPrefix, 'base', 'bg')};

        &:hover {
          background: ${getPrefixedVar(buttonPrefix, 'hover', 'bg')};
        }

        &:active {
          background: ${getPrefixedVar(buttonPrefix, 'active', 'bg')};
        }
      }
    `;
  }}
`;
